export default __webpack_public_path__ + "static/media/arrow-circle-up.223c2ef9.svg";